import {
    ACCOUNT_ROLE_ADMINISTRATOR as ROLE_ADMINISTRATOR,
    ACCOUNT_ROLE_OPERATOR as ROLE_OPERATOR,
    ACCOUNT_ROLE_BUYER as ROLE_BUYER,
    normalizeAccountRole,
} from '%evp_theme/brandbook/account/accountMenu';
import readRedesignRootAttribute from './readRedesignRootAttribute';
import isSafeUrl from './isSafeUrl';
import isNonEmptyString from './isNonEmptyString';

const KNOWN_OPERATOR_CAPACITIES = [ROLE_ADMINISTRATOR, ROLE_OPERATOR];

const SIGNED_OUT = {
    role: null,
    operatorCapacity: null,
    logoutUrl: null,
    settingsUrl: null,
    fullName: null,
    email: null,
    stopImpersonatingUrl: null,
};

function readOperatorCapacity(value) {
    if (value === null || value === undefined) {
        return null;
    }

    return KNOWN_OPERATOR_CAPACITIES.includes(value) ? value : ROLE_OPERATOR;
}

function readText(value) {
    return isNonEmptyString(value) ? value : '';
}

function normalizeRedesignAccount(data) {
    if (!data || typeof data !== 'object' || !isSafeUrl(data.logoutUrl)) {
        return SIGNED_OUT;
    }

    return {
        role: normalizeAccountRole(data.role),
        operatorCapacity: readOperatorCapacity(data.operatorCapacity),
        logoutUrl: data.logoutUrl,
        settingsUrl: isSafeUrl(data.settingsUrl) ? data.settingsUrl : null,
        fullName: readText(data.fullName),
        email: readText(data.email),
        stopImpersonatingUrl: isSafeUrl(data.stopImpersonatingUrl) ? data.stopImpersonatingUrl : null,
    };
}

function readRedesignAccount() {
    return normalizeRedesignAccount(readRedesignRootAttribute('data-redesign-account'));
}

export default readRedesignAccount;
export {
    normalizeRedesignAccount,
    SIGNED_OUT,
    ROLE_ADMINISTRATOR,
    ROLE_OPERATOR,
    ROLE_BUYER,
};
